export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8881.ed5d4053.jpg";